export default __webpack_public_path__ + "static/media/rectangle-2-breaks.d30fbe14.webp";